import { __spreadValues as i } from "./3YLGPPWQ.js";
function a(...n) {
}
function s(n, t) {
  if (f(n)) {
    const r = u(t) ? t() : t;
    return n(r);
  }
  return n;
}
function f(n) {
  return typeof n == "function";
}
function u(n) {
  return typeof n == "function";
}
function o(n, t) {
  return typeof Object.hasOwn == "function" ? Object.hasOwn(n, t) : Object.prototype.hasOwnProperty.call(n, t);
}
function d(...n) {
  return (...t) => {
    for (const r of n)
      typeof r == "function" && r(...t);
  };
}
function l(n, t) {
  const r = i({}, n);
  for (const e of t)
    o(r, e) && delete r[e];
  return r;
}
function y(n, t) {
  const r = {};
  for (const e of t)
    o(n, e) && (r[e] = n[e]);
  return r;
}
function p(n) {
  return n;
}
function v(n, t) {
  if (!n)
    throw typeof t != "string" ? new Error("Invariant failed") : new Error(t);
}
function w(n) {
  return Object.keys(n);
}
function O(n) {
  return n.disabled || n["aria-disabled"] === !0 || n["aria-disabled"] === "true";
}
function h(n) {
  const t = {};
  for (const r in n)
    n[r] !== void 0 && (t[r] = n[r]);
  return t;
}
function k(...n) {
  for (const t of n)
    if (t !== void 0) return t;
}
export {
  s as applyState,
  d as chain,
  k as defaultValue,
  O as disabledFromProps,
  w as getKeys,
  o as hasOwnProperty,
  p as identity,
  v as invariant,
  a as noop,
  l as omit,
  y as pick,
  h as removeUndefinedValues
};
//# sourceMappingURL=PBFD2E7P.js.map
